<template>
  <div class="min-h-screen bg-surface dark:bg-[#0b1c30]">
    <router-view></router-view>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useUserStore } from './stores/userStore';
import { logger } from './utils/logger';

const userStore = useUserStore();

// Initialize DuckDB when app mounts (non-blocking, without loading data)
onMounted(() => {
  logger.log('App mounted, initializing DuckDB in background...');
  // Don't await - let it initialize in background while UI renders
  // Data will be loaded on-demand when user visits specific pages
  userStore.initializeDuckDB().catch(error => {
    logger.error('Failed to initialize DuckDB:', error);
  });
});
</script>

<style>
/* Your styles here if any */
</style> 